/* React hooks */
import { useRef, useEffect, useState } from "react";
/* Routing */
import { Link, useNavigate, useLocation } from "react-router-dom";
/* Resources */
import { safeJwtDecode } from "../helper/jwtHelper";
/* Contexts */
import useAuth from "../hooks/useAuth";
/* API Context */
import { axiosBase } from "../api/fetchWrapper";
/* Components */
import FormForgottenPassword from "../forms/FormForgottenPassword";


export default function Login() {
    const { setAuth } = useAuth();
    const navigate = useNavigate();
    const location = useLocation();
    const from = location.state?.from?.pathname || "/";
    const thisYear = new Date().getFullYear();

    const userRef = useRef();
    const errRef = useRef();
    const LOGIN_URL = '/api-v1/login_check';
    const [showModal, setShowModal] = useState(false);
    const [username, setUser] = useState('');
    const [password, setPassword] = useState('');
    const [errMsg, setErrMsg] = useState('');
    const [showPassword, setShowPassword] = useState(false);

    const handleForgottenPassword = (e) => {
        e.preventDefault();
        setShowModal(true);
    }

    useEffect(() => {
        localStorage.removeItem('persist');
        localStorage.removeItem('refresh_token');
        localStorage.removeItem('old_refresh_token');
    }, []);

    useEffect(() => {
        userRef.current.focus();
        document.title = "Authentification - Obsèques en France";
    }, []);

    useEffect(() => {
        setErrMsg('');
    }, [username, password]);

    useEffect(() => {
        if (errMsg) {
            errRef.current?.focus();
        }
    }, [errMsg]);

    const handleLogin = async (e) => {
        e.preventDefault()
        try {
            const response = await axiosBase.post(
                LOGIN_URL,
                { username, password },
                {
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    withCredentials: true
                }
            );
            const token = response?.data?.token;
            const refreshToken = response?.data?.refresh_token
            localStorage.setItem('refresh_token', refreshToken)
            localStorage.setItem('persist', true)
            const decodedToken = safeJwtDecode(token);

            if (!decodedToken) {
                setErrMsg('Token invalide reçu du serveur');
                return;
            }

            const roles = decodedToken.roles;
            setAuth({ username, password, roles: roles, token: token, agency: decodedToken.agencyId });
            setUser('');
            setPassword('');
            if (roles.includes('ROLE_BACKEND')) {
                navigate('/admin/accueil')
            } else {
                navigate(from, { replace: true });
            }
        } catch (err) {
            if (!err?.response) {
                setErrMsg('Pas de réponse du serveur');
            } else if (err.response?.code === 400) {
                setErrMsg("Erreur dans l'identifiant ou le mot de passe");
            } else if (err?.response?.code === 401) {
                setErrMsg("Vous n'êtes pas autorisé")
            } else {
                setErrMsg("Vous n'avez pas pu vous connecter");
            }
        }
    };

    return (
        <section className="login-page">
            {showModal &&
                <div className="modal">
                    <FormForgottenPassword setShowModal={setShowModal} legend="Mot de passe oublié" />
                </div>
            }
            <div className="login-form">
                <h1>Authentification</h1>
                <form onSubmit={handleLogin}>
                    <label htmlFor="identifiant">Identifiant</label>
                    <input
                        type="text"
                        label="Identifiant"
                        id="login"
                        ref={userRef}
                        value={username}
                        onChange={(e) => setUser(e.target.value)}
                        required
                    />
                    <label htmlFor="password">Mot de passe</label>
                    <div className="password-input-wrapper">
                        <input
                            type={showPassword ? "text" : "password"}
                            id="Mot de passe"
                            value={password}
                            /*pattern={patternListChoices?.password}*/
                            onChange={(e) => setPassword(e.target.value)}
                            required
                        />
                        <i
                            className={showPassword ? "fa fa-eye password-toggle-icon" : "fa fa-eye-slash password-toggle-icon"}
                            onClick={() => setShowPassword(!showPassword)}
                        />
                    </div>
                    {errMsg &&
                        <div className="errors" ref={errRef}>
                            {errMsg}
                        </div>
                    }

                    <button type="submit"><span>Connexion</span><i className="fa fa-chevron-right" /></button>
                </form>
                <Link onClick={handleForgottenPassword} to="">Mot de passe oublié ?</Link>
            </div>
            <div className="help-section">
                <button className="help"><i className="fa fa-phone" /><span>Besoin d'aide ?</span></button>
                <aside><span>0 800 400 115</span></aside>
            </div>
            <span className="footer">{thisYear} - Administration d'Obsèques en France - <Link to="/mentions-legales" target="_blank"> Mentions légales et politique de confidentialité</Link></span>
        </section>
    );
}

